import { render, staticRenderFns } from "./WorkorderLayoutColumn.vue?vue&type=template&id=5a419a32&scoped=true&"
import script from "./WorkorderLayoutColumn.vue?vue&type=script&lang=js&"
export * from "./WorkorderLayoutColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a419a32",
  null
  
)

export default component.exports